import { useState } from 'react'
import { axiosUser } from '../../Utils/axios';
import { swal2 } from '../../Utils/Swal_helper';

function useAddData() {
    const [ loading, setLoading ] = useState(false);
    const [ success, setSuccess ] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const postData = async (url, data) => {
        setLoading(true);
        setSuccess(false);
        try {

            await axiosUser.post(url, data).then(response => {
                setSuccess(false);
                if (response.data.success) {

                    setLoading(false);
                    
                    setSuccess(true);

                    swal2.Toast.fire({
                        text: "Successful!",
                        icon: "success",
                        position: "top-right",
                        timerProgressBar: true,
                        timer: 3500,
                    });

                } else {
                    console.log(response.data.message)
                    setErrorMessage(response.data.message)
                }

            }).catch(error => { 
                setErrorMessage(error?.message)
                setLoading(false);
                setSuccess(false);
                console.error(error);

            })

        } catch (error) {

            setLoading(false);
            setSuccess(false);
            console.error(error);

        }
    }
    return {postData, loading, success,errorMessage}
}

export default useAddData